export const mainUrl = process.env.REACT_APP_API_URL;
